import { memo } from 'react';
import Input, { InputProps } from 'src/components/primitives/Input/Input';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

function TradeInput({
	size: sizeFromProps,
	...props
}: Omit<InputProps, 'type' | 'variant'>) {
	const isMobileScreenSize = useIsMobileScreenSize();

	const size = sizeFromProps ?? (isMobileScreenSize ? 'sm' : 'md');

	const allProps = {
		type: 'number',
		size,
		...props,
	} as InputProps;

	return <Input {...allProps} />;
}

export default memo(TradeInput);
